import React from "react";
import { Map } from "immutable";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import ReserveForSellerForm from "./ReserveForSellerForm";

function EditReserveForSeller({ editing, close, inventory, currentUser }) {
  const initialValues = {
    id: inventory.get("id"),
    reserve_for_seller_id:
      inventory.get("reserve_for_seller_id") || currentUser.get("id"),
    quantity: inventory.get("quantity") === 1 ? 1 : null
  };

  return (
    <Modal
      key={inventory.get("id")}
      open={editing}
      close={close}
      dialogClass="modal-sm"
    >
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Reserve For Sale</h4>
      </Header>
      <ReserveForSellerForm
        close={close}
        initialValues={initialValues}
        selectedSeller={
          inventory.get("reserve_for_seller") || currentUser.toJS()
        }
        enableReinitialize
      />
    </Modal>
  );
}

export default connect(state => ({
  currentUser: state.session.get("user")
}))(EditReserveForSeller);

EditReserveForSeller.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(Map),
  inventory: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/EditReserveForSeller/EditReserveForSeller.jsx